import React, {useState, useEffect} from "react";
import { Typography, CardActionArea, CardContent, Card, CardMedia, Box } from "@mui/material";
import { Link } from 'react-router-dom';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../../../firebase/firebaseConfig";

const CardService = () => {
    const [servicio, setServicio] = useState([]);

    useEffect(() => {
        onSnapshot(collection(db, 'calochoservice'),
            (snapshot) => {
                const arregloServicio = snapshot.docs.map((docServicio) => {
                    return {...docServicio.data(), id: docServicio.id};
                })
    
                setServicio(arregloServicio);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);  

    return(
        <Box sx={{ width: '100%', }}>    
            {servicio.map((infoservicio) => (                
                <CardActionArea key={infoservicio.id}  sx={{marginBottom: '5px' }}>
                    <Link style={{ textDecoration: 'none' }}>
                        <Card sx={{
                            mb: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexDirection: {
                                xs: 'column', // Cambia a columnas en dispositivos móviles
                                sm: 'row', 
                            }
                        }} >
                            <CardMedia
                                component="img"
                                sx={{ width: { xs: '50', sm: '20%'}, height: { xs: '50', sm: '20%'}, display: { xs: 'flex', sm: 'flex' } }}
                                image={infoservicio.imagen}
                                alt={infoservicio.titulo}
                                style={{ 
                                    alignItems: {xs: 'center', sm: 'center'} , 
                                    justifyContent: {xs: 'center', sm: 'center'},
                                    alignContent: {xs: 'center', sm: 'center'},
                                    textAlign: {xs: 'center', sm: 'center'},
                                    borderRadius: '1%',
                                }}
                            />
                            <CardContent sx={{ 
                                display: "flex", 
                                justifyContent: 'center' ,
                                flexDirection: 'column',
                                width: '80%',
                            }}>
                                <Typography component="h2" variant="h5" sx={{ 
                                    marginBottom: { xs: 1, sm: 2 },
                                    fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' }, 
                                    textAlign: 'center'
                                }}>
                                    {infoservicio.titulo}
                                </Typography>
                                <Typography component="h2" variant="subtitle1" sx={{ 
                                    marginBottom: { xs: 1, sm: 2 },
                                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                                    textAlign: 'center'
                                }}>
                                    {infoservicio.descripcion}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Link>
                </CardActionArea>
            ))} 
        </Box>
    );
}

export default CardService;